/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { HistoryAlbumBroadcastRecord } from "./HistoryAlbumBroadcastRecord";
import { HistoryAlbumBroadcastViewRecord } from "./HistoryAlbumBroadcastViewRecord";
import { HistoryAlbumMyRecord } from "./HistoryAlbumMyRecord";
import { HistoryAlbumReceiveGiftRecord } from "./HistoryAlbumReceiveGiftRecord";
import { HistoryAlbumSendGiftRecord } from "./HistoryAlbumSendGiftRecord";

export const protobufPackage = "Reality.Reality.Api";

export interface HistoryAlbumKeyedData {
  key: string;
  myRecord?: HistoryAlbumMyRecord | undefined;
  receiveGiftRecords: HistoryAlbumReceiveGiftRecord[];
  sendGiftRecords: HistoryAlbumSendGiftRecord[];
  broadcastRecords: HistoryAlbumBroadcastRecord[];
  broadcastViewRecords: HistoryAlbumBroadcastViewRecord[];
}

function createBaseHistoryAlbumKeyedData(): HistoryAlbumKeyedData {
  return {
    key: "",
    myRecord: undefined,
    receiveGiftRecords: [],
    sendGiftRecords: [],
    broadcastRecords: [],
    broadcastViewRecords: [],
  };
}

export const HistoryAlbumKeyedData = {
  encode(message: HistoryAlbumKeyedData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.myRecord !== undefined) {
      HistoryAlbumMyRecord.encode(message.myRecord, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.receiveGiftRecords) {
      HistoryAlbumReceiveGiftRecord.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.sendGiftRecords) {
      HistoryAlbumSendGiftRecord.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.broadcastRecords) {
      HistoryAlbumBroadcastRecord.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    for (const v of message.broadcastViewRecords) {
      HistoryAlbumBroadcastViewRecord.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumKeyedData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumKeyedData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.myRecord = HistoryAlbumMyRecord.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.receiveGiftRecords.push(HistoryAlbumReceiveGiftRecord.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.sendGiftRecords.push(HistoryAlbumSendGiftRecord.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.broadcastRecords.push(HistoryAlbumBroadcastRecord.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.broadcastViewRecords.push(HistoryAlbumBroadcastViewRecord.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumKeyedData {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      myRecord: isSet(object.myRecord) ? HistoryAlbumMyRecord.fromJSON(object.myRecord) : undefined,
      receiveGiftRecords: globalThis.Array.isArray(object?.receiveGiftRecords)
        ? object.receiveGiftRecords.map((e: any) => HistoryAlbumReceiveGiftRecord.fromJSON(e))
        : [],
      sendGiftRecords: globalThis.Array.isArray(object?.sendGiftRecords)
        ? object.sendGiftRecords.map((e: any) => HistoryAlbumSendGiftRecord.fromJSON(e))
        : [],
      broadcastRecords: globalThis.Array.isArray(object?.broadcastRecords)
        ? object.broadcastRecords.map((e: any) => HistoryAlbumBroadcastRecord.fromJSON(e))
        : [],
      broadcastViewRecords: globalThis.Array.isArray(object?.broadcastViewRecords)
        ? object.broadcastViewRecords.map((e: any) => HistoryAlbumBroadcastViewRecord.fromJSON(e))
        : [],
    };
  },

  toJSON(message: HistoryAlbumKeyedData): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.myRecord !== undefined) {
      obj.myRecord = HistoryAlbumMyRecord.toJSON(message.myRecord);
    }
    if (message.receiveGiftRecords?.length) {
      obj.receiveGiftRecords = message.receiveGiftRecords.map((e) => HistoryAlbumReceiveGiftRecord.toJSON(e));
    }
    if (message.sendGiftRecords?.length) {
      obj.sendGiftRecords = message.sendGiftRecords.map((e) => HistoryAlbumSendGiftRecord.toJSON(e));
    }
    if (message.broadcastRecords?.length) {
      obj.broadcastRecords = message.broadcastRecords.map((e) => HistoryAlbumBroadcastRecord.toJSON(e));
    }
    if (message.broadcastViewRecords?.length) {
      obj.broadcastViewRecords = message.broadcastViewRecords.map((e) => HistoryAlbumBroadcastViewRecord.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumKeyedData>, I>>(base?: I): HistoryAlbumKeyedData {
    return HistoryAlbumKeyedData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumKeyedData>, I>>(object: I): HistoryAlbumKeyedData {
    const message = createBaseHistoryAlbumKeyedData();
    message.key = object.key ?? "";
    message.myRecord = (object.myRecord !== undefined && object.myRecord !== null)
      ? HistoryAlbumMyRecord.fromPartial(object.myRecord)
      : undefined;
    message.receiveGiftRecords = object.receiveGiftRecords?.map((e) => HistoryAlbumReceiveGiftRecord.fromPartial(e)) ||
      [];
    message.sendGiftRecords = object.sendGiftRecords?.map((e) => HistoryAlbumSendGiftRecord.fromPartial(e)) || [];
    message.broadcastRecords = object.broadcastRecords?.map((e) => HistoryAlbumBroadcastRecord.fromPartial(e)) || [];
    message.broadcastViewRecords =
      object.broadcastViewRecords?.map((e) => HistoryAlbumBroadcastViewRecord.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
